import { IWidget } from "@/types/dashboard.types";
import { getHiddenWidgetIds } from "@/utils/dashboard-hidden";
import { Layouts } from "react-grid-layout";
import DashboardGrid from "@/components/dashboard/dashboard-grid";
import { DashboardWidgetsEmptyState } from "@/components/dashboard/dashboard-widgets-empty-state";

interface DashboardViewContentProps {
  widgets: IWidget[];
  layouts: Layouts | null;
  orderedWidgets: IWidget[];
  dashboard?: any;
}

export function DashboardViewContent({
  widgets,
  layouts,
  orderedWidgets,
  dashboard
}: DashboardViewContentProps) {
  if (widgets.length === 0) {
    return <DashboardWidgetsEmptyState />;
  }

  if (!layouts) {
    return null;
  }

  // Convert IWidget to Widget type for the DashboardGrid component
  const convertedWidgets = orderedWidgets.map(widget => ({
    ...widget,
    type: widget.visualizationType as any,
    formId: widget.sources?.[0]?.formId || ''
  }));

  // Also convert all widgets so they include the required 'type' and 'formId' fields
  const convertedAllWidgets = widgets.map(widget => ({
    ...widget,
    type: widget.visualizationType as any,
    formId: widget.sources?.[0]?.formId || ''
  }));

  return (
    <DashboardGrid
      widgets={convertedWidgets as any}
      layouts={layouts}
      onEdit={() => {}}
      onDelete={() => {}}
      onLayoutsChange={() => {}}
      isInteractive={false}
      rowHeight={120}
      allWidgets={convertedAllWidgets as any}
    />
  );
}
